import { plans } from "@/data/mockData";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Check } from "lucide-react";

export default function PlansPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-heading font-bold text-foreground">Planes</h1>
        <p className="text-sm text-muted-foreground mt-1">Vista previa de los planes de suscripción (solo UI).</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 max-w-4xl">
        {plans.map(plan => (
          <Card key={plan.id} className={plan.is_popular ? "border-accent-gold ring-1 ring-accent-gold" : ""}>
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle className="font-heading text-lg">{plan.name}</CardTitle>
                {plan.is_popular && <Badge className="bg-accent-gold text-accent-gold-foreground text-xs">Popular</Badge>}
              </div>
              <div className="mt-2">
                <span className="text-3xl font-bold text-foreground">${plan.price_monthly}</span>
                <span className="text-sm text-muted-foreground">/mes</span>
              </div>
              <p className="text-xs text-muted-foreground">${plan.price_yearly}/año</p>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-foreground">
                    <Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>

      <p className="text-xs text-muted-foreground">Los planes se activarán con la integración de pagos.</p>
    </div>
  );
}
